import { AnyAction, Reducer } from 'redux';
import {
  StateType,
  MakePaymentRequestAction,
  MakePaymentSuccessAction,
  MakePaymentFailureAction,
  MakePaymentUnknownStateAction,
  MakePaymentCardDeclinedStateAction,
} from './types';

import {
  MAKE_PAYMENT_FAILURE,
  MAKE_PAYMENT_REQUEST,
  MAKE_PAYMENT_SUCCESS,
  MAKE_PAYMENT_UNKNOWN_STATE,
  MAKE_PAYMENT_CARD_DECLINED,
} from './action-types';

const initialState: StateType = {
  loading: false,
  error: false,
  success: false,
  unknownState: false,
  clientSecret: '',
};

const matchMakePaymentRequest = (action: AnyAction): action is MakePaymentRequestAction =>
  action.type === MAKE_PAYMENT_REQUEST;
const matchMakePaymentSuccess = (action: AnyAction): action is MakePaymentSuccessAction =>
  action.type === MAKE_PAYMENT_SUCCESS;
const matchMakePaymentFailure = (action: AnyAction): action is MakePaymentFailureAction =>
  action.type === MAKE_PAYMENT_FAILURE;
const matchMakePaymentUnknownStateAction = (
  action: AnyAction
): action is MakePaymentUnknownStateAction => action.type === MAKE_PAYMENT_UNKNOWN_STATE;
const matchMakePaymentCardDeclined = (
  action: AnyAction
): action is MakePaymentCardDeclinedStateAction => action.type === MAKE_PAYMENT_CARD_DECLINED;

export const reducers: Reducer<StateType, AnyAction> = (state = initialState, action) => {
  if (matchMakePaymentRequest(action)) {
    return {
      ...state,
      loading: true,
      error: false,
      success: false,
      unknownState: false,
    };
  }

  if (matchMakePaymentSuccess(action)) {
    return {
      ...state,
      loading: false,
      error: false,
      success: true,
      unknownState: false,
    };
  }

  if (matchMakePaymentFailure(action)) {
    return {
      ...state,
      loading: false,
      error: true,
      success: false,
      unknownState: false,
    };
  }

  if (matchMakePaymentUnknownStateAction(action)) {
    return {
      ...state,
      loading: false,
      error: false,
      success: false,
      unknownState: true,
    };
  }

  if (matchMakePaymentCardDeclined(action)) {
    return {
      ...state,
      loading: false,
      error: true,
      success: false,
      unknownState: false,
      clientSecret: action.payload,
    };
  }

  return state;
};
